/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './Footer.style';

import uiMessages from 'src/shared/app/base/l10n/uiL10n';

import { getShortLocale } from 'src/shared/app/locale/util/localeUtils';
import {
  privacyUrl,
  termsUrl,
  privacyUrlFrench,
  termsUrlFrench,
} from 'src/shared/app/base/settings/appSettings';

import FooterLinkList from 'src/shared/ui/component/link/FooterLinkList';
import PreferenceLanguageSection from 'src/shared/app/preference/component/PreferenceLanguageSection';

const useStyles = createUseStyles(styles);

const Footer = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  const termsUrlLocalized =
    getShortLocale(intl.locale) === 'fr' ? termsUrlFrench : termsUrl;
  const privacyUrlLocalized =
    getShortLocale(intl.locale) === 'fr' ? privacyUrlFrench : privacyUrl;

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <PreferenceLanguageSection />
      <FooterLinkList
        links={[
          {
            href: privacyUrlLocalized,
            children: intl.formatMessage(uiMessages.privacy),
          },
          {
            href: termsUrlLocalized,
            children: intl.formatMessage(uiMessages.terms),
          },
        ]}
      />
    </div>
  );
};

export default compose(React.memo)(Footer);
